import { render } from "./AssignaturesView.vue?vue&type=template&id=7142d9a8"
import script from "./AssignaturesView.vue?vue&type=script&lang=js"
export * from "./AssignaturesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__